export enum AppEmbedData_AppType {
  PRODUCT = 'PRODUCT',
  EVENT = 'EVENT',
  BOOKING = 'BOOKING',
  UNRECOGNIZED = 'UNRECOGNIZED',
}